/**
 * file_name.js
 *
 * 경 로 :
 * 목 적 :
 * 진 행 :
 * 주 의 :
 * 이 슈 :
 * 일 자 : (수정 18.08.24)
 * 작 성 : (수정 Lee Mi Reu)
 * 참 조 :
 */

import Interpreter from 'interpreter/dev/script/class_acorn_interpreter';

/**
 * 네이티브 JS 개체 또는 값에서 JS 인터프리터 개체로 변환합니다.
 * JSON 스타일 값을 처리 할 수 ​​있으며 순환을 처리하지 않습니다.
 * @param {*} nativeObj 변환 할 네이티브 JS 객체입니다.
 * @return {Interpreter.Value} 해당하는 JS 인터프리터 객체입니다.
 */
Interpreter.prototype.IP_nativeToPseudo = function (nativeObj) {
	// [T]
	// console.log(this);

	if ((typeof nativeObj !== 'object' && typeof nativeObj !== 'function') ||
		nativeObj === null) {
		return nativeObj;
	}

	if (nativeObj instanceof RegExp) {
		var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
		this.populateRegExp(pseudoRegexp, nativeObj);
		return pseudoRegexp;
	}

	if (nativeObj instanceof Date) {
		var pseudoDate = this.createObjectProto(this.DATE_PROTO);
		pseudoDate.data = nativeObj;
		return pseudoDate;
	}

	if (nativeObj instanceof Function) {
		var interpreter = this;
		var wrapper = function () {
			return interpreter.nativeToPseudo(
				nativeObj.apply(interpreter,
					Array.prototype.slice.call(arguments)
						.map(function (i) {
							return interpreter.pseudoToNative(i);
						})
				)
			);
		};
		// 함수가 무조껀 Async 처리
		return this.createAsyncFunction(wrapper, undefined);
	}

	var pseudoObj;
	if (Array.isArray(nativeObj)) {  // Array.
		pseudoObj = this.createObjectProto(this.ARRAY_PROTO);
		for (var i = 0; i < nativeObj.length; i++) {
			if (i in nativeObj) {
				this.setProperty(pseudoObj, i, this.nativeToPseudo(nativeObj[i]));
			}
		}
	} else if (typeof nativeObj === 'object') {  // Object.
		pseudoObj = this.createObjectProto(this.OBJECT_PROTO);
		for (var key in nativeObj) {
			if (
				typeof nativeObj[key] == 'object'
				&&
				(
					typeof nativeObj[key].function != 'undefined'
					||
					typeof nativeObj[key].$isAsync != 'undefined'
				)
			) {
				if (nativeObj[key].$isAsync) {
					// [#] async function 추가 로직

					// [T]
					// console.log('async : ', key);
					this.setProperty(pseudoObj, key, this.createAsyncFunction(nativeObj[key].function));
				} else {
					// [#] native function 추가 로직

					// [T]
					// console.log('native : ', key);
					this.setProperty(pseudoObj, key, this.createNativeFunction(nativeObj[key].function));
				}
			} else {
				// [#] default 로직
				// 무한 참조 문제로 CODMOS 객체를 담지 않았습니다.
				// 차후 수정 예정
				if (key !== 'CODMOS' && typeof nativeObj[key] === 'object') {
					if (typeof nativeObj[key].__ob__ === 'object') delete nativeObj[key].__ob__
					this.IP_nativeToPseudo(nativeObj[key])
				}
				this.setProperty(pseudoObj, key, nativeObj[key]);
			}
		}
	}
	return pseudoObj;
};

Interpreter.prototype['IP_nativeToPseudo'] = Interpreter.prototype.IP_nativeToPseudo;

export default Interpreter;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/interpreter/dev/script/IP_nativeToPseudo.js